import { render, staticRenderFns } from "./Yazar.vue?vue&type=template&id=aa6a76e2"
import script from "./Yazar.vue?vue&type=script&lang=js"
export * from "./Yazar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports